// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function FlaskIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M27.711 24.971 20 12.115V5h1a1 1 0 1 0 0-2H11a1 1 0 1 0 0 2h1v7.115L4.289 24.971A2 2 0 0 0 6 28h20a2 2 0 0 0 1.715-3.029h-.004ZM13.858 12.906a.991.991 0 0 0 .142-.514V5h4v7.393c0 .18.049.358.142.513l4.778 7.969c-1.5.296-3.634.171-6.469-1.264-1.989-1.006-3.881-1.54-5.652-1.601l3.059-5.104ZM6 26l3.568-5.948c1.78-.217 3.788.232 5.977 1.34 2.375 1.202 4.375 1.61 6 1.61.826.004 1.65-.11 2.444-.337L26 26H6Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
